import { TableColumn } from '@/components/new/table/DataTable'
import { IExpedient } from '@/containers/logistic/expedients/interfaces/interfaces'
import OrderStatusBadge from '@/components/misc/badges/OrderStatusBadge'
import { formatDateForTable } from '@/utils/helpers'
import { AlertTriangleIcon, UploadIcon } from 'lucide-react'
import { IDocumentTable } from '@/containers/logistic/expedients/wizzardExpedient/tabs/document/interfaces'
import { ICost } from '@/containers/logistic/expedients/wizzardExpedient/tabs/cost/interfaces'

export const columns: TableColumn<ICost>[] = [
  {
    accessorKey: 'category',
    header: 'Categoría',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>{row.original.category || '-'}</p>
      )
    },
  },
  {
    accessorKey: 'cost',
    header: 'Monto',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>
          {`${row.original.cost?.amount} ${row.original.cost?.codeCurrency}` ||
            '-'}
        </p>
      )
    },
  },
  {
    accessorKey: 'observations',
    header: 'Observaciones',
    cell: ({ row }) => {
      return (
        <div className="flex justify-center">
          <p className={`max-w-28 py-1 text-left font-medium`}>
            {row.original.observations || '-'}
          </p>
        </div>
      )
    },
  },
]
